import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-status-icon',
  templateUrl: './status-icon.component.html',
  styles: []
})
export class StatusIconComponent implements OnInit {
  @Input()
  status: any;

  constructor() { }

  ngOnInit() {
  }

}
